
import React from "react";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";

interface MedewerkersHeaderProps {
  onAddMedewerker: () => void;
  canAdd?: boolean;
}

const MedewerkersHeader = ({ onAddMedewerker, canAdd = true }: MedewerkersHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-bold tracking-tight">Medewerkers</h1>
      {canAdd && (
        <Button onClick={onAddMedewerker}>
          <UserPlus className="mr-2 h-4 w-4" />
          Medewerker toevoegen
        </Button>
      )}
    </div>
  );
};

export default MedewerkersHeader;
